module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/personality-relax-btn-taiguo.aafe1ebc.png";